'use client';

import { useAppStore } from '@/store/app';
import { strategyCopy } from '@/lib/strategy';
import PortfolioSelector from '../_selector';

/** S15 组合归因 · 直达入口（无 taskId 时选择共享回测任务） */
export default function PortfolioAnalysisPickerPage() {
  const { language } = useAppStore();
  const zh = language !== 'en';
  const t = strategyCopy(zh);
  return <PortfolioSelector zh={zh} t={t} />;
}
